import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import IntroStatement from './components/IntroStatement';
import WhyJoinKiloterra from './components/WhyJoinKiloterra';
import BecomingAgent from './components/BecomingAgent';
import AboutKiloterra from './components/AboutKiloterra';
import WeAreExpanding from './components/WeAreExpanding';
import RequirementsForSuccess from './components/RequirementsForSuccess';
import KiloterraApproach from './components/KiloterraApproach';
import FromOurAgents from './components/FromOurAgents';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import ThankYouPagePreview from './components/ThankYouPagePreview';
import ThankYouPage from './components/ThankYouPage';

function App() {

  return (
    <Routes>
      <Route path="/thank-you" element={<ThankYouPage />} />
      <Route path="/" element={
        <div className="min-h-screen bg-white">
          <Navigation />
          <Hero />
          <IntroStatement />
          <WhyJoinKiloterra />
          <BecomingAgent />
          <AboutKiloterra />
          <WeAreExpanding />
          <RequirementsForSuccess />
          <KiloterraApproach />
          <FromOurAgents />
          <FinalCTA />
          <Footer />
        </div>
      } />
    </Routes>
  );
}

export default App;